export const environment = {
  production: false,
  apiUrl: 'https://cnp2360-niti-dms.developer24x7.com/api',
};
